import styled from "@emotion/styled";
import StyledCard from "../../components/generic/StyledCard";

export const StyledSigninDiv = styled.div`
  .ant-otp {
    display: flex;
    justify-content: space-around;
    margin-top: 10px;
  }
  .ant-otp-input-wrapper input {
    width: 45px;
    height: 45px;
  }
`;

export const StyledSignUpDiv = styled.div`
  .signup-div {
    max-height: 80dvh;
    overflow-y: scroll;
    overflow-x: hidden;
    .middle-area {
      overflow-y: auto;
      flex: 1 1 0%;
    }

    .signup-title {
      font-size: 25px;
      font-weight: 500;
      color: #000000;
      margin: 20px 0px;
    }

    .submit-button {
      width: 100%;
    }
    .login-link {
      padding-top: 10px;
    }
  }
`;
